import { LandingCardInterface } from "../Interfaces/landing-card";
import { AppConstants } from "./app-constants";

export class LandingConstants {
  static availableCharts: LandingCardInterface[] = [
    {
      "imgClassName": "bar-chart", "displayName": "Bar Chart",
      "chartCategory": AppConstants.barChartCategoryPathMap.chartCategory,
      "chartId": 1,
      "selectedImgClassName": "selected-bar-chart",
      "chartSelectedNumber": 0,
      isAvailable: true,
      sorting:1,
    },
    {
      "imgClassName": "stacked-bar-chart", "displayName": "Stack bar Chart",
      "chartCategory": AppConstants.stackedBarChartCategoryPathMap.chartCategory,
      "chartId": 2,
      "selectedImgClassName": "selected-stacked-bar-chart",
      "chartSelectedNumber": 0,
      isAvailable: true
    },
    {
      "imgClassName": "pie-chart", "displayName": "Pie Chart",
      "chartCategory": AppConstants.pieCategoryPathMap.chartCategory,
      "chartId": 3,
      "selectedImgClassName": "selected-pie-chart",
      "chartSelectedNumber": 0,
      isAvailable: true,
      sorting:6,
    },
    {
      "imgClassName": "area-chart", "displayName": "Area Chart",
      "chartCategory": AppConstants.areaCategoryPathMap.chartCategory,
      "chartId": 4,
      "selectedImgClassName": "selected-area-chart",
      "chartSelectedNumber": 0,
      isAvailable: true
    },    
    {
      "imgClassName": "line-chart", "displayName": "Trend Chart",
      "chartCategory": AppConstants.lineOrTrendCategoryPathMap.chartCategory,
      "chartId": 5,
      "selectedImgClassName": "selected-line-chart",
      "chartSelectedNumber": 0,
      isAvailable: true,
      sorting:9,
    },
    {
      "imgClassName": "scatter-chart", "displayName": "Scatter Chart",
      "chartCategory": AppConstants.scatterCategoryPathMap.chartCategory,
      "chartId": 6,
      "selectedImgClassName": "selected-scatter-chart",
      "chartSelectedNumber": 0,
      isAvailable: true,
      sorting:7,
    },
    {
      "imgClassName": "lollipop-chart", "displayName": "Lollipop Chart",
      "chartCategory": AppConstants.lollipopChartCategoryPathMap.chartCategory,
      "chartId": 7,
      "selectedImgClassName": "selected-lollipop-chart",
      "chartSelectedNumber": 0,
      isAvailable: true,
      sorting:2,
    },
    // {
    //   "imgClassName": "lollipop-chart", "displayName": "Funnel Chart",
    //   "chartCategory": AppConstants.lollipopChartCategoryPathMap.chartCategory,
    //   "chartId":8,
    //   "selectedImgClassName":"selected-lollipop-chart",
    //   "chartSelectedNumber": 0,
    // },
    // {
    //   "imgClassName": "spider-chart", "displayName": "Spider Chart",
    //   "chartCategory": AppConstants.spiderCategoryPathMap.chartCategory,
    //   "chartId":8,
    //   "selectedImgClassName":"selected-spider-chart"
    // },
    // {
    //   "imgClassName": "unique-chart1", "displayName": "Unique Chart 1",
    //   "chartCategory": AppConstants.uniqueCategoryPathMap1.chartCategory,
    //   "chartId":8,
    //   "selectedImgClassName":"selected-unique-chart1"
    // },
    {
      "imgClassName": "unique-chart2", "displayName": "Funnel Chart",
      "chartCategory": AppConstants.uniqueCategoryPathMap2.chartCategory,
      "chartId": 8,
      "selectedImgClassName": "selected-unique-chart",
      isAvailable: true,
      sorting:8,
    },
    {
      "imgClassName": "Table-chart", "displayName": "Others",
      "chartCategory": AppConstants.TableCategoryPathMap.chartCategory,
      "chartId": 9,
      "selectedImgClassName": "selected-Table-chart",
      "chartSelectedNumber": 0,
      isAvailable: true,
      sorting:10,
    }
    // {
    //  "imgClassName": "combination-chart", "displayName": "Combination Chart",
    //  "chartCategory": AppConstants.combinationCategoryPathMap.chartCategory
    // },
    // {
    //  "imgClassName": "box-plot-series-chart", "displayName": "Box Plot Series Chart",
    //  "chartCategory": AppConstants.boxPlotSeriesCategoryPathMap.chartCategory
    // },
    // {
    //   "imgClassName": "pyramid-chart", "displayName": "Pyramid Chart",
    //   "chartCategory": AppConstants.pyramidChartCategoryPathMap.chartCategory
    // },
  ]
}
